'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/noquote.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _constants = require('@marmalade/contact/lib/constants');
var _grid = require('@marmalade/grid');
var _panel = require('@marmalade/panel');
var _progressBar = require('@marmalade/progress-bar');
var _glamorous = require('glamorous');
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRouterDom = require('react-router-dom');
var _constants2 = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var NoQuote = function (_Component) {
  _inherits(NoQuote, _Component);
  function NoQuote() {
    _classCallCheck(this, NoQuote);
    return _possibleConstructorReturn(this, (NoQuote.__proto__ || Object.getPrototypeOf(NoQuote)).apply(this, arguments));
  }
  _createClass(NoQuote, [{
    key: 'render',
    value: function render() {
      var isWhitelabel = this.props.theme.name !== 'Marmalade';
      var Element = this.props.container ? _grid.Container : _react.Fragment;
      return _react2.default.createElement(Element, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        },
        __self: this
      }, _react2.default.createElement(_progressBar.WithStages, {
        newBusinessStages: _constants2.stages,
        active: 4,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22
        },
        __self: this
      }), _react2.default.createElement(_panel.Panel, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        },
        __self: this
      }, _react2.default.createElement('h1', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        },
        __self: this
      }, 'We\'re sorry but we cannot insure you with the details you have provided'), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        },
        __self: this
      }, 'Although we cannot offer you Learner Driver cover you may still qualify for ', isWhitelabel ? 'Marmalade\'s ' : 'our ', _react2.default.createElement('a', {
        href: 'https://www.wearemarmalade.co.uk/black-box-insurance',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        },
        __self: this
      }, 'Black Box Insurance'), ' ', 'or', ' ', _react2.default.createElement('a', {
        href: 'https://www.wearemarmalade.co.uk/cars-for-young-drivers',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        },
        __self: this
      }, 'Cars for Young Drivers'), ' ', 'products.', _react2.default.createElement('br', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        },
        __self: this
      }), 'Find out more by clicking the links above, or give us a call on ', _constants.phone.ldi, '.')));
    }
  }]);
  return NoQuote;
}(_react.Component);
NoQuote.propTypes = {
  container: _propTypes.bool
};
exports.default = (0, _reactRouterDom.withRouter)((0, _glamorous.withTheme)(NoQuote));